import VrTourPopupInit from './partials/vr-tour-popup';

const vrTourBlock = document.querySelector('.vr-tour-block');
const button = vrTourBlock.querySelector('button');
const dialog = vrTourBlock.querySelector('dialog');

if (button && button.dataset.vrUrl) {
  VrTourPopupInit(button, dialog);
}
